import React from 'react';

const getHeight = (isMobile: boolean, isPreview: boolean) => {
  if (isPreview) {
    return '82px';
  }

  if (isMobile) {
    return '74px';
  }

  return '128px';
};

interface IHeaderSkeleton {
  $isMobile: boolean;
  $isPreview: boolean;
}

export const HeaderSkeleton = ({ $isMobile, $isPreview }: IHeaderSkeleton) => (
  <div
    style={{
      height: getHeight($isMobile, $isPreview),
      background: 'var(--lime)',
    }}
  />
);
